import React, { forwardRef, useImperativeHandle } from 'react';
import { Table } from '@ajaibid/components';

import OrderActionProvider from '../components/OrderActionProvider';
import Detail from './components/Detail';
import useColumns from './hooks/useColumns';
import useOrderDt from './hooks/useOrderDt';
import { styTable, styWrapper } from './style';

function getRowId(row, ix, parent) {
  return `${parent ? `${parent?.id}__` : ''}${row?.order_no || ix}`; // Real one
}

/**
 * @type  {import('@ajaibid/components').TableProps['renderRowExpand']}
 */
function renderRowExpand(row) {
  return <Detail item={row.original} />;
}

const StockOpenOrderDT = forwardRef((_, ref) => {
  const { data, isInitialLoading, refetch, isRefetching, fetchNextPage, isFetchingNextPage } =
    useOrderDt();

  const columns = useColumns();

  useImperativeHandle(ref, () => ({
    // Allow the following functions & variables to be called from its parents
    refetchTable: refetch,
    isRefetching: isRefetching,
  }));

  return (
    <OrderActionProvider>
      <div className={styWrapper}>
        <Table
          className={styTable}
          data={data}
          columns={columns}
          options={{ isHeaderVisible: true, isRowExpandable: true }}
          fetchNext={fetchNextPage}
          getRowId={getRowId}
          isInitialLoading={isInitialLoading}
          isFetchingNext={isFetchingNextPage}
          renderRowExpand={renderRowExpand}
          emptyStateContent="Mulai bertransaksi dan lihat statusnya di sini."
        />
      </div>
    </OrderActionProvider>
  );
});

export default StockOpenOrderDT;
